module.exports = __webpack_public_path__ + "static/img/design-3.f5a3b525.png";